import React, { useEffect, useCallback, useState} from 'react';
import SettingsModal from 'components/modals/SettingsModal.js';
import ProgressBar from 'components/progressbar/ProgressBar.js';
import UnknownProgressBar from 'components/progressbar/UnknownProgressBar.js';
import LoginModal from 'components/modals/LoginModal.js';
import SavePresetModal from 'components/modals/SavePresetModal.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import GuildsModal from "components/modals/GuildsModal.js";
import {connect} from 'react-redux';

const Modals = (props) => { 
    let loadingSequence = Object.keys(props.loadingSequence).some(
        (s) => props.loadingSequence[s]);

    return (
        <div>
          <ConditionedComponent condition={props.showLogin}>
	    <LoginModal show={props.showLogin}/>
          </ConditionedComponent>
          {loadingSequence ? 
           <ProgressBar sequencerEngine={props.sequencerEngine}/> : ''}
          {props.loadingText ? 
           <UnknownProgressBar text={props.loadingText} sequencerEngine={props.sequencerEngine}/> : ''}
          {props.transcribing ? 
           <UnknownProgressBar text="Transcribing" sequencerEngine={props.sequencerEngine}/> : ''}
           <GuildsModal/>
          {props.uploadingFile ? 
           <UnknownProgressBar text="Uploading File" sequencerEngine={props.sequencerEngine}/> : ''}
          {props.showSettings ?
           <SettingsModal sequencerEngine={props.sequencerEngine}/> : ''}
          {props.trackPresetSaving ?
           <SavePresetModal sequencerEngine={props.sequencerEngine}/> : ''}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      trackPresetSaving: state.presets.trackPresetSaving,
      showLogin: state.sequencer.showLogin,
      transcribing: state.sequencer.isTranscribing,
      loadingText: state.sequencer.loadingText,
      loadingSequence: state.sequencer.loadingSequence,
      uploadingFile: state.sequencer.uploadingFile,
      showSettings: state.sequencer.showSettings
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
